import { render } from "./MainTemplates.vue?vue&type=template&id=229e90e6"
import script from "./MainTemplates.vue?vue&type=script&lang=js"
export * from "./MainTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__